// import * as moment from 'jalali-moment';

function number_3_3(num, sep) {
  var number = typeof num === "number" ? num.toString() : num,
    separator = typeof sep === "undefined" ? "," : sep;
  return number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + separator);
}

// const PersianDate = (date) => moment(date).locale('fa').format('YYYY/M/D');

// const PersianDateDay = (dada) => {
//     let m = moment(dada);
//     m.locale('fa');
//     return m.format('dddd');
// }

export { number_3_3 };
